import * as Joi from 'joi';

const iExamCandidateCreateEditDetails = Joi.object({
    authentication: Joi.string()
        .required()
        .messages({
            'string.required': 'Authentication is not allowed to be empty',
            'any.required': 'Authentication is not allowed to be empty',
        }),
    email: Joi.string()
        .email({tlds: {allow: false}})
        .messages({
            'string.based': 'Email is not allowed to be empty',
            'string.empty': 'Email is not allowed to be empty',
            'string.email': 'Please enter a valid email.',
        })
});
export default iExamCandidateCreateEditDetails;
